import {environment} from '../../../../environments/environment';

import {IconId} from '../../../shared/components/icon/icon.types';
export interface MenuItem {
    isSeparator?: boolean;
    id?: number;
    key?: string;
    label?: string;
    icon?: IconId;
    svgBackgroundUrl?: string;
    link?: string;
    collapsed?: boolean;
    children?: MenuItem[];
    isTitle?: boolean;
    parentKey?: string;
    necessaryRoles?: '*' | string[];
    collapsable?: boolean;
    /**
     * Určuje, zda se má nedostupná položka úplně skrýt z menu
     * - true = úplně skrýt (nezobrazovat ani v "Objevte více funkcí")
     * - false/undefined = zobrazit v "Objevte více funkcí" když není dostupná (výchozí chování)
     */
    hideWhenUnavailable?: boolean;
    queryParams?: Record<string, string>;
    /**
     * Dostupnost funkce ve free plánu — řídí zobrazení korunky v levém menu
     * - 'unavailable' = funkce není ve free plánu vůbec dostupná
     * - 'limited' = funkce je ve free plánu dostupná jen omezeně
     */
    freePlanAvailability?: 'unavailable' | 'limited';
    /**
     * Položka se zobrazí, jen když má tenant zapnutý tento feature flag.
     */
    featureFlag?: string;
}


// menu items for vertical and detached layout
export const MENU_ITEMS: MenuItem[] = [
    {
        key: 'apps-dashboard',
        label: 'MENU.Dashboard',
        isTitle: false,
        icon: 'app:dashboard', // Modernější dashboard ikona
        collapsed: true,
        link: '/page/dashboard',
        necessaryRoles: "*",
    },

    // -------------------------- PERSONALIZATION ---------------------------------------------------
    {
        key: 'apps-personalization',
        label: 'MENU.Personalization',
        isTitle: false,
        icon: 'app:personalization',
        link: '/page/personalization',
        necessaryRoles: "*",
    },
    // -------------------------- /PERSONALIZATION -------------------------------------------------

    // -------------------------- CO JE NOVÉHO -------------------------------------------------
    // Patří do horního neseskupeného bloku (vedle Dashboardu a Personalizace). Dole za
    // titulkem „Nástroje“ se to renderovalo vizuálně dovnitř té skupiny — sidebar sází
    // titulky inline, takže položka bez `parentKey` za titulkem vypadá jako jeho člen.
    // Odznak nekonfigurujeme přes `badge` — vykresluje se jako počet nepřečtených
    // v left-sidebar.component.html (dřív tu byl natvrdo anglický řetězec 'NEW'
    // v česky-first aplikaci, a k tomu `variant: 'error'`, tedy červená pro novinku).
    ...(environment.whatsNewEnabled ? [{
        key: 'apps-whats-new',
        label: 'MENU.WhatsNew',
        isTitle: false,
        icon: 'app:whatsNew',
        link: '/page/whats-new',
        necessaryRoles: '*',
    } satisfies MenuItem] : []),
    // -------------------------- /CO JE NOVÉHO -----------------------------------------------

    // -------------------------- TVORBA --------------------------------------------------------
    {
        key: 'apps-creation',
        label: 'MENU.group.creation',
        isTitle: true,
    },
    {
        key: 'apps-chats',
        label: 'MENU.Chats',
        parentKey: 'apps-creation',
        icon: 'app:chats',
        link: '/page/chats',
        necessaryRoles: "*",
    },
    {
        key: 'apps-images-list',
        label: 'MENU.Images.Gallery',
        parentKey: 'apps-creation',
        icon: 'app:images',
        link: '/page/images',
        necessaryRoles: "*",
        hideWhenUnavailable: false,
        freePlanAvailability: 'limited',
    },
    {
        key: 'apps-audio',
        label: 'MENU.Audio',
        parentKey: 'apps-creation',
        icon: 'app:audio',
        link: '/page/audio',
        necessaryRoles: "*",
        freePlanAvailability: 'unavailable',
    },
    {
        key: 'apps-documents',
        label: 'MENU.Documents',
        parentKey: 'apps-creation',
        icon: 'app:documents',
        link: '/page/subjects/list',
        queryParams: {type: 'generic_document', viewMode: 'CARDS'},
        necessaryRoles: '*',
    },
    {
        key: 'apps-presentations',
        label: 'MENU.Presentations',
        parentKey: 'apps-creation',
        icon: 'app:presentations',
        link: '/page/presentations',
        necessaryRoles: "*",
    },
    {
        key: 'apps-copywriting',
        label: 'MENU.Copywriting',
        parentKey: 'apps-creation',
        icon: 'app:copywriting',
        link: '/page/subjects/list',
        queryParams: {type: 'copy'},
        necessaryRoles: '*',
    },
    {
        key: 'apps-social',
        label: 'MENU.Social',
        parentKey: 'apps-creation',
        icon: 'app:social',
        link: '/page/social',
        necessaryRoles: "*",
        freePlanAvailability: 'limited',
    },
    {
        key: 'apps-recipes',
        label: 'MENU.Recipes',
        parentKey: 'apps-creation',
        icon: 'app:recipes',
        link: '/page/recipes',
        necessaryRoles: "*",
    },
    // -------------------------- /TVORBA -------------------------------------------------------

    // -------------------------- NÁSTROJE -------------------------------------------------------
    {
        key: 'apps-tools',
        label: 'MENU.group.tools',
        isTitle: true,
    },
    {
        key: 'apps-translator',
        label: 'MENU.Translator',
        parentKey: 'apps-tools',
        icon: 'app:translator',
        link: '/page/translator',
        necessaryRoles: "*",
    },
    {
        key: 'apps-paraphraser',
        label: 'MENU.Paraphraser',
        parentKey: 'apps-tools',
        icon: 'app:paraphraser',
        link: '/page/paraphraser',
        necessaryRoles: "*",
        freePlanAvailability: 'limited',
    },
    {
        key: 'apps-ai-detector',
        label: 'MENU.AIDetector',
        parentKey: 'apps-tools',
        icon: 'app:aiDetector',
        link: '/page/ai-detector',
        necessaryRoles: "*",
        freePlanAvailability: 'unavailable',
    },
    {
        key: 'apps-integrations',
        label: 'MENU.Integrations',
        parentKey: 'apps-tools',
        icon: 'app:integrations',
        link: '/page/integrations',
        necessaryRoles: '*',
    },
    // -------------------------- /NÁSTROJE -----------------------------------------------------

    // -------------------------- WEB EDITOR -------------------------------------------------------

    // {
    //     key: 'airdoc-main',
    //     label: 'MENU.Documents',
    //     icon: 'app:documents', // Více dokumentů (stejná jako karta)
    //     necessaryRoles: "*",
    //     collapsed: true,
    //     collapsable: true,
    //     children: [
    //         {
    //             key: 'airdoc-list',
    //             label: 'MENU.WebEditor.List',
    //             icon: 'ph:files', // Seznam dokumentů
    //             parentKey: 'airdoc-main',
    //             link: '/page/papers/air',
    //             necessaryRoles: "*",
    //         },
    //         {
    //             key: 'airdoc-prompt',
    //             label: 'MENU.WebEditor.New',
    //             icon: 'ph:file-plus', // Nový dokument
    //             parentKey: 'airdoc-main',
    //             link: '/page/papers/air/blank',
    //             necessaryRoles: "*",
    //         },
    //     ]
    // },
    // -------------------------- /WEB EDITOR --------------------------------------------------------

    // -------------------------- OFFICE SUITE -------------------------------------------------------
    // {
    //     key: 'doc-main',
    //     label: 'MENU.CoreDocs',
    //     link: '/page/papers/core',
    //     icon: 'ph:microsoft-word-logo', // Dokument
    //     necessaryRoles: ["guideglare_top", "guideglare_zero"],
    //     hideWhenUnavailable: false, // Zobrazit v "Objevte více funkcí"
    //     collapsed: true,
    //     collapsable: true,
    //     children: [
    //         {
    //             key: 'doc-list',
    //             label: 'MENU.CoreDocs.List',
    //             link: '/page/papers/core',
    //             parentKey: 'doc-main',
    //             icon: 'ph:files', // Více dokumentů
    //             necessaryRoles: ["guideglare_top", "guideglare_zero"],
    //             hideWhenUnavailable: false
    //         },
    //
    //         {
    //             key: 'doc-prompt',
    //             label: 'MENU.CoreDocs.New',
    //             link: '/page/papers/core/blank',
    //             parentKey: 'doc-main',
    //             icon: 'ph:file-plus', // Nový dokument
    //             necessaryRoles: ["guideglare_top", "guideglare_zero"],
    //             hideWhenUnavailable: true
    //         },
    //     ]
    // },
    // -------------------------- /OFFICE SUITE --------------------------------------------------
    // -------------------------- /EDITORS -------------------------------------------------------


    // ---------------------------- OTHERS ------------------------------------------------------
    /*    {
            key: 'otherst',
            label: 'MENU.Others',
            isTitle: true
        },
        {
            key: 'my-account',
            label: 'MENU.group.my-account',
            collapsed: true,
            collapsable: true,
            icon: 'ph:user', // Uživatelský účet
            children: [
                {
                    key: 'feedback-list',
                    label: 'MENU.SendFeedback',
                    link: '/page/misc/feedback',
                    parentKey: 'my-account',
                    icon: 'ph:chat-circle-text' // Zpětná vazba
                },
                {
                    key: 'passwd-change',
                    label: 'MENU.PasswdChange',
                    link: '/page/subscription/password-change',
                    parentKey: 'my-account',
                    icon: 'ph:key' // Změna hesla
                },
                {
                    key: 'admin-settings',
                    label: 'MENU.AdminSettings',
                    link: '/page/admin/settings',
                    parentKey: 'my-account',
                    icon: 'app:settings',
                    necessaryRoles: ["admin"],
                    hideWhenUnavailable: true // Úplně skrýt pro non-admin uživatele
                },
            ]
        },*/

/*    {
        key: 'subscriptions',
        label: 'MENU.MySubscription',
        icon: 'app:subscription', // Ikona předplatného
        collapsed: true,
        collapsable: true,
        children: [
            {
                key: 'subscription',
                label: 'MENU.SubscriptionDetail',
                link: '/page/subscription',
                parentKey: 'subscriptions',
                icon: 'ph:identification-card' // Detail předplatného
            },
            {
                key: 'invoices',
                label: 'MENU.MyInvoices',
                link: '/page/subscription/invoices',
                parentKey: 'subscriptions',
                icon: 'ph:invoice' // Faktury
            }
        ]
    },*/
    // ---------------------------- /OTHERS -----------------------------------------------------
];
